import { z } from 'zod/v3';

import { CountryCode } from 'common/api-types/common';

import { OverrideReason, OverrideStatus } from './api-types';

export const overridesRouteSearchSchema = z.object({
  countryCodes: z.custom<CountryCode[]>().optional(),
  overrideReasons: z.custom<OverrideReason[]>().optional(),
  page: z.coerce.number().optional(),
  pageSize: z.coerce.number().optional(),
  productFamilies: z.array(z.string()).optional(),
  q: z.coerce.string().optional(),
  statuses: z.custom<OverrideStatus[]>().optional(),
  uploadOverrideCsvModalOpen: z.boolean().optional(),
  deleteOverridesModalOpen: z.boolean().optional(),
  venueCodes: z.array(z.string()).optional(),
  viewAllOverridesModalOpen: z.boolean().optional(),
});
